export enum ParcelTool {
  SelectParcel = "select-parcel",
  CombineParcels = "combine-parcels",
  DrawParcel = "draw-parcel",
  EditParcel = "edit-parcel",
  DeleteParcel = "delete-parcel",
}
